"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateAndInstallPixelsRequestStatus = exports.getUninstallPixelRequestStatus = exports.getFetchPixelsRequestStatus = exports.getInstalledPixels = exports.getPixels = void 0;

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getPixels = function getPixels(state) {
  return state.modules.marketing.ads.entities.pixelSettings.get('pixels');
};

exports.getPixels = getPixels;
var getInstalledPixels = (0, _reselect.createSelector)(getPixels, function (pixels) {
  return pixels.filter(function (pixel) {
    return pixel.installed;
  });
});
exports.getInstalledPixels = getInstalledPixels;
var getFetchPixelsRequestStatus = (0, _getRequestStatus.default)(_actions.AdsPixelActionTypes.FETCH_PIXELS);
exports.getFetchPixelsRequestStatus = getFetchPixelsRequestStatus;
var getUninstallPixelRequestStatus = (0, _getRequestStatus.default)(_actions.AdsPixelActionTypes.UNINSTALL_PIXEL);
exports.getUninstallPixelRequestStatus = getUninstallPixelRequestStatus;
var getCreateAndInstallPixelsRequestStatus = (0, _getRequestStatus.default)(_actions.AdsPixelActionTypes.CREATE_AND_INSTALL_PIXELS);
exports.getCreateAndInstallPixelsRequestStatus = getCreateAndInstallPixelsRequestStatus;